module.exports = __webpack_public_path__ + "img/73.bf34cafa.jpg";